import { render, staticRenderFns } from "./SDetailPaymentComp.vue?vue&type=template&id=6fe0142b&"
import script from "./SDetailPaymentComp.vue?vue&type=script&lang=js&"
export * from "./SDetailPaymentComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports